import ajax from '@/utils/ajax';

const header = '/web';

// 获取直播推荐列表
// eslint-disable-next-line import/prefer-default-export
export const getLiveBJY = (data) => ajax(`${header}/v1/baijiayun/live/player/params?roomId=${data.roomId}&userProductId=${data.userProductId}`, {}, 'POST');
